import { render, staticRenderFns } from "./VehicleRenewPolicy.vue?vue&type=template&id=23013330&scoped=true&"
import script from "./VehicleRenewPolicy.vue?vue&type=script&lang=js&"
export * from "./VehicleRenewPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23013330",
  null
  
)

export default component.exports